// removed by extract-text-webpack-plugin
module.exports = {"header":"style__header___3l06B","title":"style__title___2zpD7","pulse":"style__pulse___1CF10"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/Logo/style.scss
 ** module id = 357
 ** module chunks = 0
 **/